import React, {
useCallback,
useEffect,
useMemo,
useState,
} from "react";

import {
Button,
Card,
Col,
Input,
Row,
Select,
Space,
Table,
Tag,
Popconfirm,
Empty,
message,
Grid,
Typography,
Divider,
Pagination,
} from "antd";

import {
PlusOutlined,
DollarOutlined,
EditOutlined,
DeleteOutlined,
EyeOutlined,
SearchOutlined,
} from "@ant-design/icons";

import api from "../api/api";

import {
useAcademicYear,
} from "../AcademicYearContext";

import FeesForm from "./FeesForm";

import FeesDetailsPopup from "./FeesDetailsPopup";
import "./OtherFeePaymentTable.css";

const {
useBreakpoint,
} = Grid;

const {
Text,
} = Typography;

const MONTHS = [


{
    value: "january",
    label: "January",
},

{
    value: "february",
    label: "February",
},

{
    value: "march",
    label: "March",
},

{
    value: "april",
    label: "April",
},

{
    value: "may",
    label: "May",
},

{
    value: "june",
    label: "June",
},

{
    value: "july",
    label: "July",
},

{
    value: "august",
    label: "August",
},

{
    value: "september",
    label: "September",
},

{
    value: "october",
    label: "October",
},

{
    value: "november",
    label: "November",
},

{
    value: "december",
    label: "December",
},


];

const OtherFeesPayment = () => {


const {
    selectedYear,
} = useAcademicYear();


const screens =
    useBreakpoint();


const isMobile =
    !screens.md;


const [
    payments,
    setPayments,
] = useState([]);


const [
    totalPayments,
    setTotalPayments,
] = useState(0);


const [
    feeTypes,
    setFeeTypes,
] = useState([]);


const [
    students,
    setStudents,
] = useState([]);


const [
    classes,
    setClasses,
] = useState([]);


const [
    loading,
    setLoading,
] = useState(false);


const [
    studentsLoading,
    setStudentsLoading,
] = useState(false);


const [
    searchInput,
    setSearchInput,
] = useState("");


const [
    search,
    setSearch,
] = useState("");


const [
    studentSearch,
    setStudentSearch,
] = useState("");


const [
    selectedFeeType,
    setSelectedFeeType,
] = useState(null);


const [
    selectedMonth,
    setSelectedMonth,
] = useState(null);


const [
    selectedStudent,
    setSelectedStudent,
] = useState(null);


const [
    selectedClass,
    setSelectedClass,
] = useState(null);


const [
    currentPage,
    setCurrentPage,
] = useState(1);


const [
    pageSize,
    setPageSize,
] = useState(25);


const [
    formOpen,
    setFormOpen,
] = useState(false);


const [
    formMode,
    setFormMode,
] = useState("payment");


const [
    editingPayment,
    setEditingPayment,
] = useState(null);


const [
    detailsOpen,
    setDetailsOpen,
] = useState(false);


const [
    selectedPayment,
    setSelectedPayment,
] = useState(null);


const getResults =
    response => {

        if (
            Array.isArray(
                response?.data
            )
        ) {

            return response.data;

        }

        return response?.data?.results || [];

    };


const fetchFeeTypes =
    useCallback(
        async () => {

            try {

                const response =
                    await api.get(
                        "/other-fee-types/",
                        {
                            params: {

                                page_size:
                                    100,

                            },

                        }
                    );


                setFeeTypes(
                    getResults(
                        response
                    )
                );

            } catch (error) {

                console.error(
                    "Error fetching fee types:",
                    error
                );

                message.error(
                    "Unable to load fee types."
                );

            }

        },
        []
    );


const fetchClasses =
    useCallback(
        async () => {

            try {

                const response =
                    await api.get(
                        "/api/users/grade-classes/",
                        {
                            params: {

                                page_size:
                                    100,

                            },

                        }
                    );


                setClasses(
                    getResults(
                        response
                    )
                );

            } catch (error) {

                console.error(
                    "Error fetching classes:",
                    error
                );

                message.error(
                    "Unable to load classes."
                );

            }

        },
        []
    );


const fetchStudents =
    useCallback(
        async searchValue => {

            if (
                !selectedYear
            ) {

                setStudents([]);

                return;

            }


            try {

                setStudentsLoading(
                    true
                );


                const params = {

                    academic_year:
                        selectedYear.id,

                    page:
                        1,

                    page_size:
                        25,

                };


                if (
                    searchValue?.trim()
                ) {

                    params.search =
                        searchValue.trim();

                }


                const response =
                    await api.get(
                        "api/users/students/",
                        {
                            params,
                        }
                    );


                setStudents(
                    getResults(
                        response
                    )
                );

            } catch (error) {

                console.error(
                    "Error fetching students:",
                    error
                );

            } finally {

                setStudentsLoading(
                    false
                );

            }

        },
        [
            selectedYear,
        ]
    );


const fetchPayments =
    useCallback(
        async () => {

            if (
                !selectedYear
            ) {

                setPayments([]);

                setTotalPayments(
                    0
                );

                return;

            }


            try {

                setLoading(
                    true
                );


                const params = {

                    academic_year:
                        selectedYear.id,

                    page:
                        currentPage,

                    page_size:
                        pageSize,

                };


                if (
                    search.trim()
                ) {

                    params.search =
                        search.trim();

                }


                if (
                    selectedFeeType
                ) {

                    params.fee_type =
                        selectedFeeType;

                }


                if (
                    selectedMonth
                ) {

                    params.month =
                        selectedMonth;

                }


                if (
                    selectedStudent
                ) {

                    params.student =
                        selectedStudent;

                }


                if (
                    selectedClass
                ) {

                    params.student_class =
                        selectedClass;

                }


                const response =
                    await api.get(
                        "/other-fee-payments/",
                        {
                            params,
                        }
                    );


                setPayments(
                    response.data.results || []
                );


                setTotalPayments(
                    response.data.count || 0
                );

            } catch (error) {

                console.error(
                    "Error fetching payments:",
                    error
                );

                message.error(
                    "Unable to load payments."
                );

            } finally {

                setLoading(
                    false
                );

            }

        },
        [
            selectedYear,
            currentPage,
            pageSize,
            search,
            selectedFeeType,
            selectedMonth,
            selectedStudent,
            selectedClass,
        ]
    );


useEffect(
    () => {

        const timer =
            setTimeout(
                () => {

                    setSearch(
                        searchInput.trim()
                    );

                    setCurrentPage(
                        1
                    );

                },
                500
            );


        return () => {

            clearTimeout(
                timer
            );

        };

    },
    [
        searchInput,
    ]
);


useEffect(
    () => {

        fetchFeeTypes();

        fetchClasses();

    },
    [
        fetchFeeTypes,
        fetchClasses,
    ]
);


useEffect(
    () => {

        fetchStudents(
            ""
        );

    },
    [
        fetchStudents,
    ]
);


useEffect(
    () => {

        fetchPayments();

    },
    [
        fetchPayments,
    ]
);


useEffect(
    () => {

        setCurrentPage(
            1
        );

    },
    [
        selectedFeeType,
        selectedMonth,
        selectedStudent,
        selectedClass,
    ]
);


const handleFeeTypeCreated =
    newFeeType => {

        setFeeTypes(
            previous => [

                newFeeType,

                ...previous,

            ]
        );


        setFormMode(
            "payment"
        );


        setFormOpen(
            true
        );

    };


const handlePaymentCreated =
    () => {

        setCurrentPage(
            1
        );

        fetchPayments();

    };


const handlePaymentUpdated =
    () => {

        fetchPayments();

    };


const handleDelete =
    async paymentId => {

        try {

            await api.delete(
                `/other-fee-payments/${paymentId}/`
            );


            message.success(
                "Payment deleted successfully."
            );


            if (
                payments.length === 1 &&
                currentPage > 1
            ) {

                setCurrentPage(
                    currentPage - 1
                );

            } else {

                fetchPayments();

            }

        } catch (error) {

            console.error(
                "Error deleting payment:",
                error
            );


            message.error(
                "Unable to delete payment."
            );

        }

    };


const openAddFeeType =
    () => {

        setEditingPayment(
            null
        );


        setFormMode(
            "fee_type"
        );


        setFormOpen(
            true
        );

    };


const openPaymentForm =
    () => {

        setEditingPayment(
            null
        );


        setFormMode(
            "payment"
        );


        setFormOpen(
            true
        );

    };


const openEditForm =
    payment => {

        setEditingPayment(
            payment
        );


        setFormMode(
            "payment"
        );


        setFormOpen(
            true
        );

    };


const openDetails =
    payment => {

        setSelectedPayment(
            payment
        );


        setDetailsOpen(
            true
        );

    };


const formatMonth =
    value => {

        if (
            !value
        ) {

            return "N/A";

        }


        return (

            value
                .charAt(0)
                .toUpperCase()
            +
            value.slice(1)

        );

    };


const formatAmount =
    value => {

        return Number(
            value || 0
        ).toFixed(2);

    };


const renderActions =
    payment => (

        <Space
            wrap
        >

            <Button

                type="primary"

                ghost

                icon={
                    <EditOutlined />
                }

                onClick={() =>
                    openEditForm(
                        payment
                    )
                }

            >

                Edit

            </Button>


            <Popconfirm

                title="Delete this payment?"

                description={
                    "This action cannot be undone."
                }

                okText="Yes, Delete"

                cancelText="Cancel"

                okButtonProps={{
                    danger: true,
                }}

                onConfirm={() =>
                    handleDelete(
                        payment.id
                    )
                }

            >

                <Button

                    danger

                    icon={
                        <DeleteOutlined />
                    }

                >

                    Delete

                </Button>

            </Popconfirm>


            <Button

                icon={
                    <EyeOutlined />
                }

                onClick={() =>
                    openDetails(
                        payment
                    )
                }

            >

                Details

            </Button>

        </Space>

    );


const columns =
    useMemo(
        () => [

            {

                title: "#",

                key: "index",

                width: 55,

                render: (
                    _,
                    __,
                    index
                ) => (

                    (
                        currentPage - 1
                    )
                    *
                    pageSize
                )
                +
                index
                +
                1,

            },

            {

                title: "Fee Type",

                dataIndex:
                    "fee_type_name",

                key:
                    "fee_type_name",

                ellipsis:
                    true,

            },

            {

                title: "Payer Name",

                dataIndex:
                    "payer_name",

                key:
                    "payer_name",

                ellipsis:
                    true,

                render:
                    value => (

                        <strong>

                            {
                                value ||
                                "N/A"
                            }

                        </strong>

                    ),

            },

            {

                title: "Student",

                dataIndex:
                    "student_name",

                key:
                    "student_name",

                ellipsis:
                    true,

                responsive: [
                    "lg",
                ],

                render:
                    value =>

                        value ||
                        "Manual Payer",

            },

            {

                title: "Class",

                dataIndex:
                    "student_class_name",

                key:
                    "student_class_name",

                ellipsis:
                    true,

                responsive: [
                    "lg",
                ],

                render:
                    value =>

                        value ||
                        "N/A",

            },

            {

                title: "Total",

                dataIndex:
                    "total_amount",

                key:
                    "total_amount",

                render:
                    value => (

                        <strong>

                            {
                                formatAmount(
                                    value
                                )
                            }

                        </strong>

                    ),

            },

            {

                title: "Paid",

                dataIndex:
                    "amount_paid",

                key:
                    "amount_paid",

                render:
                    value => (

                        <Tag
                            color="green"
                        >

                            {
                                formatAmount(
                                    value
                                )
                            }

                        </Tag>

                    ),

            },

            {

                title: "Balance",

                dataIndex:
                    "balance",

                key:
                    "balance",

                responsive: [
                    "lg",
                ],

                render:
                    value => (

                        <Tag

                            color={

                                Number(
                                    value || 0
                                ) > 0

                                    ? "red"

                                    : "green"

                            }

                        >

                            {
                                formatAmount(
                                    value
                                )
                            }

                        </Tag>

                    ),

            },

            {

                title: "Month",

                dataIndex:
                    "month",

                key:
                    "month",

                responsive: [
                    "lg",
                ],

                render:
                    formatMonth,

            },

            {

                title: "Date",

                dataIndex:
                    "date",

                key:
                    "date",

                responsive: [
                    "xl",
                ],

            },

            {

                title: "Actions",

                key:
                    "actions",

                width: 260,

                render: (
                    _,
                    payment
                ) =>

                    renderActions(
                        payment
                    ),

            },

        ],
        [
            currentPage,
            pageSize,
            payments,
        ]
    );


const renderMobilePayment =
    payment => (

        <Card

            key={
                payment.id
            }

            size="small"

            style={{
                marginBottom: 12,
            }}

            title={

                <Space>

                    <Text
                        strong
                    >

                        {
                            payment.fee_type_name ||
                            "Other Fee"
                        }

                    </Text>

                </Space>

            }

            extra={

                <Tag
                    color={
                        Number(
                            payment.balance || 0
                        ) > 0
                            ? "red"
                            : "green"
                    }
                >

                    Balance:

                    {" "}

                    {
                        formatAmount(
                            payment.balance
                        )
                    }

                </Tag>

            }

        >

            <Row
                gutter={[
                    12,
                    12
                ]}
            >

                <Col
                    span={12}
                >

                    <Text
                        type="secondary"
                    >

                        Payer

                    </Text>

                    <br />

                    <Text
                        strong
                    >

                        {
                            payment.payer_name ||
                            "N/A"
                        }

                    </Text>

                </Col>


                <Col
                    span={12}
                >

                    <Text
                        type="secondary"
                    >

                        Student

                    </Text>

                    <br />

                    <Text>

                        {
                            payment.student_name ||
                            "Manual Payer"
                        }

                    </Text>

                </Col>


                <Col
                    span={12}
                >

                    <Text
                        type="secondary"
                    >

                        Class

                    </Text>

                    <br />

                    <Text>

                        {
                            payment.student_class_name ||
                            "N/A"
                        }

                    </Text>

                </Col>


                <Col
                    span={12}
                >

                    <Text
                        type="secondary"
                    >

                        Month

                    </Text>

                    <br />

                    <Text>

                        {
                            formatMonth(
                                payment.month
                            )
                        }

                    </Text>

                </Col>


                <Col
                    span={12}
                >

                    <Text
                        type="secondary"
                    >

                        Total

                    </Text>

                    <br />

                    <Text
                        strong
                    >

                        {
                            formatAmount(
                                payment.total_amount
                            )
                        }

                    </Text>

                </Col>


                <Col
                    span={12}
                >

                    <Text
                        type="secondary"
                    >

                        Paid

                    </Text>

                    <br />

                    <Tag
                        color="green"
                    >

                        {
                            formatAmount(
                                payment.amount_paid
                            )
                        }

                    </Tag>

                </Col>

            </Row>


            <Divider
                style={{
                    margin: "14px 0",
                }}
            />


            <Space
                wrap
                style={{
                    width: "100%",
                }}
            >

                <Button

                    type="primary"

                    ghost

                    icon={
                        <EditOutlined />
                    }

                    onClick={() =>
                        openEditForm(
                            payment
                        )
                    }

                >

                    Edit

                </Button>


                <Popconfirm

                    title="Delete this payment?"

                    description={
                        "This action cannot be undone."
                    }

                    okText="Yes, Delete"

                    cancelText="Cancel"

                    okButtonProps={{
                        danger: true,
                    }}

                    onConfirm={() =>
                        handleDelete(
                            payment.id
                        )
                    }

                >

                    <Button

                        danger

                        icon={
                            <DeleteOutlined />
                        }

                    >

                        Delete

                    </Button>

                </Popconfirm>


                <Button

                    icon={
                        <EyeOutlined />
                    }

                    onClick={() =>
                        openDetails(
                            payment
                        )
                    }

                >

                    Details

                </Button>

            </Space>

        </Card>

    );


return (

    <div
        style={{

            width: "100%",

            maxWidth: "100%",

            padding: isMobile
                ? 12
                : 24,

            boxSizing:
                "border-box",

        }}
    >

        <Card

            title={

                <div>

                    <div
                        style={{
                            fontSize: isMobile
                                ? 18
                                : 22,

                            fontWeight: 700,

                        }}
                    >

                        Other Fees Payments

                    </div>


                    <div
                        style={{

                            fontSize: 13,

                            color: "#777",

                            marginTop: 4,

                        }}
                    >

                        Academic Year:

                        {" "}

                        <strong>

                            {
                                selectedYear?.name ||
                                "No active academic year"
                            }

                        </strong>

                    </div>

                </div>

            }

            extra={

                <Space
                    wrap
                >

                    <Button

                        icon={
                            <PlusOutlined />
                        }

                        onClick={
                            openAddFeeType
                        }

                    >

                        {!isMobile &&
                            "Add Fee Type"
                        }

                    </Button>


                    <Button

                        type="primary"

                        icon={
                            <DollarOutlined />
                        }

                        onClick={
                            openPaymentForm
                        }

                    >

                        {!isMobile &&
                            "Process Payment"
                        }

                    </Button>

                </Space>

            }

            bodyStyle={{
                padding: isMobile
                    ? 12
                    : 24,
            }}

        >

            <Row

                gutter={[
                    12,
                    12
                ]}

                style={{
                    marginBottom: 20,
                }}

            >

                <Col
                    xs={24}
                    sm={24}
                    md={12}
                    lg={8}
                >

                    <Input

                        prefix={
                            <SearchOutlined />
                        }

                        placeholder="Search payer, student or fee type"

                        value={
                            searchInput
                        }

                        onChange={event =>
                            setSearchInput(
                                event.target.value
                            )
                        }

                        allowClear

                    />

                </Col>


                <Col
                    xs={24}
                    sm={12}
                    md={6}
                    lg={4}
                >

                    <Select

                        placeholder="Fee Type"

                        style={{
                            width: "100%",
                        }}

                        value={
                            selectedFeeType
                        }

                        onChange={
                            value => {

                                setSelectedFeeType(
                                    value
                                );

                                setCurrentPage(
                                    1
                                );

                            }
                        }

                        allowClear

                        showSearch

                        optionFilterProp="children"

                    >

                        {
                            feeTypes.map(
                                feeType => (

                                    <Select.Option

                                        key={
                                            feeType.id
                                        }

                                        value={
                                            feeType.id
                                        }

                                    >

                                        {
                                            feeType.fee_type_name
                                        }

                                    </Select.Option>

                                )
                            )
                        }

                    </Select>

                </Col>


                <Col
                    xs={24}
                    sm={12}
                    md={6}
                    lg={4}
                >

                    <Select

                        placeholder="Month"

                        style={{
                            width: "100%",
                        }}

                        value={
                            selectedMonth
                        }

                        onChange={
                            value => {

                                setSelectedMonth(
                                    value
                                );

                                setCurrentPage(
                                    1
                                );

                            }
                        }

                        allowClear

                    >

                        {
                            MONTHS.map(
                                month => (

                                    <Select.Option

                                        key={
                                            month.value
                                        }

                                        value={
                                            month.value
                                        }

                                    >

                                        {
                                            month.label
                                        }

                                    </Select.Option>

                                )
                            )
                        }

                    </Select>

                </Col>


                <Col
                    xs={24}
                    sm={12}
                    md={6}
                    lg={4}
                >

                    <Select

                        placeholder="Class"

                        style={{
                            width: "100%",
                        }}

                        value={
                            selectedClass
                        }

                        onChange={
                            value => {

                                setSelectedClass(
                                    value
                                );

                                setCurrentPage(
                                    1
                                );

                            }
                        }

                        allowClear

                        showSearch

                        optionFilterProp="children"

                    >

                        {
                            classes.map(
                                gradeClass => (

                                    <Select.Option

                                        key={
                                            gradeClass.id
                                        }

                                        value={
                                            gradeClass.id
                                        }

                                    >

                                        {
                                            gradeClass.name
                                        }

                                    </Select.Option>

                                )
                            )
                        }

                    </Select>

                </Col>


                <Col
                    xs={24}
                    sm={12}
                    md={6}
                    lg={4}
                >

                    <Select

                        placeholder="Search student"

                        style={{
                            width: "100%",
                        }}

                        value={
                            selectedStudent
                        }

                        onChange={
                            value => {

                                setSelectedStudent(
                                    value
                                );

                                setCurrentPage(
                                    1
                                );

                            }
                        }

                        showSearch

                        filterOption={
                            false
                        }

                        onSearch={
                            fetchStudents
                        }

                        loading={
                            studentsLoading
                        }

                        allowClear

                        notFoundContent={

                            studentsLoading
                                ? "Searching..."
                                : "No students found"

                        }

                    >

                        {
                            students.map(
                                student => (

                                    <Select.Option

                                        key={
                                            student.id
                                        }

                                        value={
                                            student.id
                                        }

                                    >

                                        {
                                            student.full_name
                                        }

                                    </Select.Option>

                                )
                            )
                        }

                    </Select>

                </Col>

            </Row>


            {
                isMobile

                    ?

                    <>

                        {
                            payments.length > 0

                                ?

                                payments.map(
                                    renderMobilePayment
                                )

                                :

                                <Empty

                                    description={

                                        selectedYear

                                            ?

                                            "No payments found."

                                            :

                                            "Select an academic year."

                                    }

                                />

                        }


                        {
                            totalPayments > 0 && (

                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent:
                                            "center",

                                        marginTop: 20,

                                    }}
                                >

                                    <Pagination

                                        current={
                                            currentPage
                                        }

                                        pageSize={
                                            pageSize
                                        }

                                        total={
                                            totalPayments
                                        }

                                        showSizeChanger

                                        pageSizeOptions={[
                                            10,
                                            25,
                                            50,
                                        ]}

                                        onChange={(
                                            page,
                                            newPageSize
                                        ) => {

                                            setCurrentPage(
                                                page
                                            );

                                            setPageSize(
                                                newPageSize
                                            );

                                        }}

                                    />

                                </div>

                            )

                        }

                    </>

                    :

                    <Table
                        className="other-fees-payment-table"
                        rowKey="id"

                        columns={
                            columns
                        }

                        dataSource={
                            payments
                        }

                        loading={
                            loading
                        }

                        locale={{

                            emptyText: (

                                <Empty

                                    description={

                                        selectedYear

                                            ?

                                            "No payments found."

                                            :

                                            "Select an academic year."

                                    }

                                />

                            ),

                        }}

                        pagination={{

                            current:
                                currentPage,

                            pageSize:
                                pageSize,

                            total:
                                totalPayments,

                            showSizeChanger:
                                true,

                            pageSizeOptions: [
                                "10",
                                "25",
                                "50",
                                "100",
                            ],

                            showTotal:
                                total =>

                                    `Total ${total} payments`,

                            onChange: (
                                page,
                                newPageSize
                            ) => {

                                setCurrentPage(
                                    page
                                );

                                setPageSize(
                                    newPageSize
                                );

                            },

                        }}

                    />

            }

        </Card>


        <FeesForm

            open={
                formOpen
            }

            mode={
                formMode
            }

            editingPayment={
                editingPayment
            }

            feeTypes={
                feeTypes
            }

            students={
                students
            }

            classes={
                classes
            }

            selectedYear={
                selectedYear
            }

            onClose={() => {

                setFormOpen(
                    false
                );

                setEditingPayment(
                    null
                );

            }}

            onFeeTypeCreated={
                handleFeeTypeCreated
            }

            onPaymentCreated={
                handlePaymentCreated
            }

            onPaymentUpdated={
                handlePaymentUpdated
            }

        />


        <FeesDetailsPopup

            open={
                detailsOpen
            }

            payment={
                selectedPayment
            }

            onClose={() => {

                setDetailsOpen(
                    false
                );

                setSelectedPayment(
                    null
                );

            }}

        />

    </div>

);


};

export default OtherFeesPayment;
